import { render, staticRenderFns } from "./OauthBtn.vue?vue&type=template&id=5ea89b0b&scoped=true"
import script from "./OauthBtn.vue?vue&type=script&lang=js"
export * from "./OauthBtn.vue?vue&type=script&lang=js"
import style0 from "./OauthBtn.vue?vue&type=style&index=0&id=5ea89b0b&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea89b0b",
  null
  
)

export default component.exports